import { createReducer } from "@reduxjs/toolkit";
import type { TrainingInvoice } from "@shared-kernel/application/ports/admin/admin-repository";
import { retrieveTrainingInvoiceList } from "./retrieve-training-invoice-list";
import type { RetrievalState } from "@redux/state/shared-types";
import type { PaginatedResult } from "@shared-kernel/domain/types/paginated-result";

const initialState: RetrievalState<PaginatedResult<TrainingInvoice>> = {
  fetching: "idle",
  data: {
    items: [],
    page: 1,
    pageSize: 50,
    total: 0,
    totalPages: 0,
  },
};

export const retrieveTrainingInvoiceListReducer = createReducer(initialState, builder => {
  builder.addCase(retrieveTrainingInvoiceList.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveTrainingInvoiceList.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveTrainingInvoiceList.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
